import PercentageBar from './PercentageBar';

export { PercentageBar };
export default PercentageBar;
